import cart from './modules/cart';
import offer from './modules/offer';

export default {
  cart,
  offer,
};
